export function isCompanyActive(value) {
	if (value === false || value === 0 || value === "0") return false;
	if (value === true || value === 1 || value === "1") return true;
	if (value == null) return false;
	return Boolean(value);
}
